import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { 
  UserPlus, 
  Bot, 
  Building2, 
  FileText, 
  Settings, 
  RefreshCw,
  ClipboardList
} from 'lucide-react';
import { useState } from 'react';

export function QuickActionsPanel() {
  const navigate = useNavigate();
  const [lastRefresh, setLastRefresh] = useState(new Date());
  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = () => {
    setIsRefreshing(true);
    // Trigger page refresh by updating state
    setLastRefresh(new Date());
    window.location.reload();
  };

  const actions = [
    {
      icon: Bot,
      label: 'Create Agent',
      description: 'New simulation agent',
      onClick: () => navigate('/admin/agents/create'),
      color: 'bg-primary/10 text-primary hover:bg-primary/20',
    },
    {
      icon: UserPlus,
      label: 'Create User',
      description: 'Add new user',
      onClick: () => navigate('/admin/users/create'),
      color: 'bg-emerald-500/10 text-emerald-500 hover:bg-emerald-500/20',
    },
    {
      icon: Building2,
      label: 'Create Company',
      description: 'New organization',
      onClick: () => navigate('/admin/companies/create'),
      color: 'bg-blue-500/10 text-blue-500 hover:bg-blue-500/20',
    },
    {
      icon: ClipboardList,
      label: 'Add Assessment',
      description: 'Physical assessment',
      onClick: () => navigate('/admin/assessments/create'),
      color: 'bg-orange-500/10 text-orange-500 hover:bg-orange-500/20',
    },
    {
      icon: Settings,
      label: 'Settings',
      description: 'Platform settings',
      onClick: () => navigate('/settings'),
      color: 'bg-muted text-muted-foreground hover:bg-muted/80',
    },
  ];

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-4">
        <div>
          <CardTitle className="flex items-center gap-2">
            ⚡ Quick Actions
          </CardTitle>
          <CardDescription>Common admin tasks</CardDescription>
        </div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <span>Updated: {lastRefresh.toLocaleTimeString()}</span>
          <Button 
            variant="ghost" 
            size="icon" 
            className="h-8 w-8"
            onClick={handleRefresh}
            disabled={isRefreshing}
          >
            <RefreshCw className={`h-4 w-4 ${isRefreshing ? 'animate-spin' : ''}`} />
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {actions.map((action) => (
            <button
              key={action.label}
              onClick={action.onClick}
              className={`flex flex-col items-center justify-center p-4 rounded-lg transition-colors ${action.color}`}
            >
              <action.icon className="h-6 w-6 mb-2" />
              <span className="text-sm font-medium">{action.label}</span>
              <span className="text-xs opacity-70">{action.description}</span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
